var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"content__buttons-row",attrs:{"type":"flex","justify":"end"}},[_c('el-col',{attrs:{"span":24}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }